export default __webpack_public_path__ + "static/media/POST_Bank.08313420.png";